import { render } from "./ChartPartogram.vue?vue&type=template&id=dab015c2"
import script from "./ChartPartogram.vue?vue&type=script&lang=js"
export * from "./ChartPartogram.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__